import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import services from '../../services';
import { useDispatch } from 'react-redux';
import { toggleDate, toggleTable } from '../../Redux/slice';
import { getAllDateTableTask } from '../../Redux/GetSlice';
import { getLocalStorageItem, setLocalStorageItem } from '../../utils/Localstorage/localStorageUtils';

const ArchivedHeader = ({ isArchivedView }) => {
    const [activeButton, setActiveButton] = useState('board');
    const [boardName, setBoardName] = useState([]);
    const [selectedBoard, setSelectedBoard] = useState(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        getAllBoard();
    }, []);

    const getAllBoard = async () => {
        try {
            const { data } = await services.board.GETALLBOARD();
            const mapData = data?.map(({ boardName, id }) => ({ label: boardName, value: id }));
            setBoardName(mapData);
            const savedBoardId = getLocalStorageItem('boardId')
            if (savedBoardId && mapData.length > 0) {
                const board = mapData.find((b) => b.value === savedBoardId);
                setSelectedBoard(board || mapData[0]);
            } else if (mapData.length > 0) {
                setSelectedBoard(mapData[0]);
            }
        } catch (e) {
            console.error(e);
        }
    };

    const handleClick = (button) => {
        setActiveButton(button);
        const boardId = selectedBoard?.value;

        if (button === 'board') {
            dispatch(toggleTable(false));
            dispatch(toggleDate(false));
            navigate('/app');
        } else if (button === 'date') {
            if (boardId) {
                dispatch(getAllDateTableTask({ data: { boardId } }));
            }
            dispatch(toggleDate(true));
            dispatch(toggleTable(false));
            navigate('/app');
        } else if (button === 'table') {
            dispatch(toggleTable(true));
            dispatch(toggleDate(false));
            navigate('/app');
        }
    };

    const handleSelectedBoard = (e) => {
        setSelectedBoard(e);
        setLocalStorageItem('boardId', e?.value)
        window.location.reload();
    };

    const getButtonClass = (button) =>
        `p-[7px] ${activeButton === button ? 'bg-[#20212414]' : 'bg-white'
        } mr-[5px] items-center flex cursor-pointer text-black gap-[4px] rounded-[5px]`;

    return (
        <div className="header-app flex items-center p-2 border-b">
            <div className="flex-1">
                <button
                    onClick={() => { isArchivedView == false ? navigate("/kanban") : navigate(-1) }}
                    className="px-4 py-2 font-semibold text-blue-500 bg-white border border-blue-500 rounded-md hover:bg-blue-50"
                >
                    Back
                </button>
            </div>
            <div className="flex-1 flex justify-center">

            </div>

        </div>
    );
};

export default ArchivedHeader; 